import { DEFAULT_SCHEMA } from '../constants'

export const initialSchemaState = {
  schema: { ...DEFAULT_SCHEMA },
}
